import { createContext } from 'preact'

export const LightboxContext = createContext({})
export const LightboxProvider = LightboxContext.Provider
